// import 'shared/avatar/avatar.js';
// import { __ } from 'i18n';
// import { html } from 'lit';
// import { until } from 'lit/directives/until.js';
// import { _converse, api } from '@converse/headless';

// import '../styles/occupant.scss';

// /**
//  * @param {import('../occupant').default} el
//  */
// export default (el) => {
//     const model = el.model ?? el.message;
//     const jid = model?.get('jid');
//     const vcard = el.getVcard();
//     const nick = model.get('nick');
//     const occupant_id = model.get('occupant_id');
//     const role = el.model?.get('role');
//     const affiliation = el.model?.get('affiliation');
//     const hats = el.model?.get('hats')?.length ? el.model.get('hats') : null;
//     const muc = el.model.collection.chatroom;

//     const i18n_add_to_contacts = __('Add to Contacts');

//     const allowed_commands = muc.getAllowedCommands();
//     const may_moderate = allowed_commands.includes('modtools');
//     const can_see_real_jids = muc.features.get('nonanonymous') || muc.getOwnRole() === 'moderator';

//     const bare_jid = _converse.session.get('bare_jid');
//     const not_me = jid != bare_jid;
//     const chat_button = not_me
//         ? html`
//               <li>
//                   <button class="btn btn-secondary w-40 mb-2" type="button" @click=${(ev) => el.openChat(ev)}>
//                       <converse-icon class="fa fa-comments" size="1em"></converse-icon>Відкрити чат
//                   </button>
//               </li>
//           `
//         : '';

//     const add_to_contacts = api.settings.get('singleton')
//         ? '' // in singleton mode, there is no roster, so adding to contact makes no sense.
//         : api.contacts
//               .get(jid)
//               .then((contact) => !contact && not_me && can_see_real_jids)
//               .then((add) =>
//                   add
//                       ? html`<li>
//                             <button class="btn btn-primary" type="button" @click=${() => el.addToContacts()}>
//                                 ${i18n_add_to_contacts}
//                             </button>
//                         </li>`
//                       : '',
//               );

//     return html`
//         <div class="row">
//             <div class="col-auto">
//                 <converse-avatar
//                     .model=${el.model}
//                     class="avatar modal-avatar"
//                     name="${el.model.getDisplayName()}"
//                     nonce=${vcard?.get('vcard_updated')}
//                     height="120"
//                     width="120"
//                 ></converse-avatar>
//             </div>
//             <div class="col">
//                 <ul class="occupant-details list-unstyled">
//                     <li class="row mb-2">
//                         <div class="col text-start"><strong>${__('Nickname')}:</strong></div>
//                         <div class="col text-end">${nick}</div>
//                     </li>
//                     <li class="row mb-2">
//                         <div class="col text-start"><strong>${__('XMPP Address')}:</strong></div>
//                         <div class="col text-end">
//                             ${jid ? html`<a href="#" @click="${el.openChat}">${jid}</a>` : ''}
//                         </div>
//                     </li>
//                     <li class="row mb-2">
//                         <div class="col text-start"><strong>${__('Affiliation')}:</strong></div>
//                         <div class="col text-end">
//                             ${affiliation}&nbsp;
//                             ${may_moderate
//                                 ? html` <a
//                                       href="#"
//                                       data-form="affiliation-form"
//                                       class="toggle-form"
//                                       @click=${(ev) => el.toggleForm(ev)}
//                                       ><converse-icon class="fa fa-wrench" size="1em"></converse-icon>
//                                   </a>`
//                                 : ''}
//                         </div>
//                         ${el.show_affiliation_form
//                             ? html`<div class="row mt-2">
//                                   <converse-muc-affiliation-form
//                                       jid=${jid}
//                                       .muc=${muc}
//                                       affiliation=${affiliation}
//                                   ></converse-muc-affiliation-form>
//                               </div>`
//                             : ''}
//                     </li>
//                     <li class="row mb-2">
//                         <div class="col text-start"><strong>${__('Role')}:</strong></div>
//                         <div class="col text-end">
//                             ${role}&nbsp;
//                             ${may_moderate && role
//                                 ? html` <a
//                                       href="#"
//                                       data-form="row-form"
//                                       class="toggle-form"
//                                       @click=${(ev) => el.toggleForm(ev)}
//                                       ><converse-icon class="fa fa-wrench" size="1em"></converse-icon>
//                                   </a>`
//                                 : ''}
//                         </div>
//                         ${el.show_role_form
//                             ? html`<div class="row mt-2">
//                                   <converse-muc-role-form jid=${jid} .muc=${muc} role=${role}></converse-muc-role-form>
//                               </div>`
//                             : ''}
//                     </li>
//                     <li class="row mb-2">
//                         <div class="col text-start"><strong>${__('Hats')}:</strong></div>
//                         <div class="col text-end">${hats}</div>
//                     </li>
//                     <li class="row mb-2">
//                         <div class="col text-start"><strong>${__('Occupant Id')}:</strong></div>
//                         <div class="col text-end text-occupant-id">${occupant_id}</div>
//                     </li>
//                     <hr />
//                     ${chat_button} ${until(add_to_contacts, '')}
//                 </ul>
//             </div>
//         </div>
//     `;
// };
import 'shared/avatar/avatar.js';
import { __ } from 'i18n';
import { html } from 'lit';
import { until } from 'lit/directives/until.js';
import { _converse, api } from '@converse/headless';

import '../styles/occupant.scss';

/**
 * @param {import('../occupant').default} el
 */
export default (el) => {
    const model = el.model ?? el.message;
    const jid = model?.get('jid') || '';
    const vcard = el.getVcard();
    const nick = model.get('nick');
    const occupant_id = model.get('occupant_id');
    const role = el.model?.get('role');
    const affiliation = el.model?.get('affiliation');
    const muc = el.model.collection.chatroom;

    // Логика обработки JID и Номера (из твоего примера)
    const jidParts = jid.split('@');
    const fullLogin = jidParts[0] || '';
    const userLogin = fullLogin.length > 2 ? fullLogin.slice(2) : fullLogin;
    const organization = jidParts[1] ? jidParts[1].replace('sonata.', '') : '';
    const selectedCode = localStorage.getItem('s_selected_domain_code') || '';
    const company = `${selectedCode} ${userLogin}`;

    const allowed_commands = muc.getAllowedCommands();
    const may_moderate = allowed_commands.includes('modtools');
    const can_see_real_jids = muc.features.get('nonanonymous') || muc.getOwnRole() === 'moderator';

    const bare_jid = _converse.session.get('bare_jid');
    const not_me = jid != bare_jid;

    // Кнопка открытия чата в новом дизайне
    const chat_button = not_me
        ? html`<button class="btn btn-primary w-100 mb-2" type="button" @click="${(ev) => el.openChat(ev)}"><converse-icon class="fas fa-comments" color="var(--background-color)" size="1em"></converse-icon> ${__('Відкрити чат')}</button>`
        : '';

    // Кнопка добавления в контакты в новом дизайне
    const add_to_contacts = api.settings.get('singleton')
        ? ''
        : api.contacts
              .get(jid)
              .then((contact) => !contact && not_me && can_see_real_jids)
              .then((add) =>
                  add
                      ? html`<div class="info-item"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.3942 19.2133V15.9668H11.1485C10.7143 15.9668 10.3619 15.6152 10.3619 15.1809C10.3619 14.7466 10.7143 14.3942 11.1485 14.3942H14.3942V11.1485C14.3942 10.7143 14.7466 10.3619 15.1809 10.3619C15.6152 10.3619 15.9668 10.7143 15.9668 11.1485V14.3942H19.2133C19.6476 14.3942 20 14.7466 20 15.1809C19.9999 15.6152 19.6476 15.9668 19.2133 15.9668H15.9668V19.2133C15.9668 19.6476 15.6152 19.9999 15.1809 20C14.7466 20 14.3942 19.6476 14.3942 19.2133Z" fill="#9AB9FF"/><path d="M5.68945e-05 17.84C5.68786e-05 16.5709 -0.0089166 15.7679 0.198534 15.0942C0.646787 13.6385 1.80341 12.499 3.28105 12.0574C3.96492 11.853 4.78001 11.8618 6.06819 11.8618H8.49795C8.92353 11.8618 9.26834 12.2015 9.26834 12.6208C9.26834 13.0401 8.92353 13.3798 8.49795 13.3798H6.06819C4.66818 13.3798 4.13872 13.388 3.7288 13.5105C2.74368 13.8049 1.97231 14.5648 1.67347 15.5353C1.54919 15.9392 1.54084 16.4608 1.54084 17.84C1.54084 18.2593 1.19603 18.599 0.77045 18.599C0.34487 18.599 5.68945e-05 18.2593 5.68945e-05 17.84ZM12.0404 5.02924C12.0404 3.09011 10.4446 1.51795 8.47626 1.51795C6.50795 1.51795 4.91213 3.09011 4.91213 5.02924C4.91213 6.96837 6.50795 8.54053 8.47626 8.54053C10.4446 8.54053 12.0404 6.96837 12.0404 5.02924ZM13.5812 5.02924C13.5812 7.80691 11.2957 10.0585 8.47626 10.0585C5.65679 10.0585 3.37135 7.80691 3.37135 5.02924C3.37135 2.25156 5.65679 0 8.47626 0C11.2957 0 13.5812 2.25156 13.5812 5.02924Z" fill="#9AB9FF"/></svg> <span class="info-label" style="cursor:pointer" @click="${() => el.addToContacts()}">Додати до контактів</span></div>`
                      : '',
              );

    return html`<div class="occupant-modal"><div class="mb-4 centered"><converse-avatar .model="${el.model}" class="avatar modal-avatar" name="${el.model.getDisplayName()}" nonce="${vcard?.get('vcard_updated')}" height="96" width="96"></converse-avatar></div><div class="centered mb-3"><strong>${nick}</strong></div><div class="sonata-card"><div class="info-item"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18.3623 0.0721707C18.5117 0.0288019 18.7632 -0.0341002 19.0383 0.0224795L19.1574 0.0543569L19.2933 0.108736C19.5561 0.23239 19.7679 0.444049 19.8915 0.706906L19.9459 0.842854L19.9777 0.961925C20.0342 1.23708 19.9705 1.48866 19.9271 1.63791C19.8718 1.82839 19.7812 2.06007 19.6862 2.30359L13.3585 18.517C13.2525 18.7886 13.1546 19.0408 13.0604 19.2314C12.9797 19.3945 12.8207 19.6943 12.5025 19.8596C12.1414 20.0472 11.7112 20.0467 11.3503 19.8587C11.0326 19.693 10.8738 19.3937 10.7933 19.2305C10.6993 19.0398 10.6018 18.7868 10.4961 18.5151L7.97315 12.0271L1.48425 9.50413C1.21264 9.39851 0.960454 9.3009 0.769824 9.20692C0.606669 9.12648 0.306422 8.96711 0.140717 8.64907C-0.0470593 8.28827 -0.0467522 7.8587 0.140717 7.49773L0.208222 7.38522C0.378628 7.14041 0.626251 7.00946 0.768887 6.93894C0.959449 6.84474 1.21184 6.74767 1.48331 6.64173L17.6966 0.314064C17.9402 0.219019 18.1718 0.127499 18.3623 0.0721707ZM9.46294 11.6221L11.9278 17.9582L17.5588 3.52618L9.46294 11.6221ZM2.04116 8.07246L8.3763 10.5364L16.4731 2.43954L2.04116 8.07246Z" fill="#9AB9FF"/></svg> <span class="info-label" style="cursor:pointer" @click="${(ev) => el.openChat(ev)}">Написати повідомлення</span></div>${until(add_to_contacts, '')}</div><div class="sonata-card"><div class="info-item"><svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18.5189 11.6364C18.5189 10.0298 17.1921 8.72711 15.5557 8.72711H4.44434C2.80792 8.72711 1.48115 10.0298 1.48115 11.6364C1.48115 13.2431 2.80792 14.5458 4.44434 14.5458H15.5557C17.1921 14.5458 18.5189 13.2431 18.5189 11.6364ZM4.45339 10.9093C4.86249 10.9093 5.19396 11.2348 5.19396 11.6364C5.19396 12.0381 4.86249 12.3636 4.45339 12.3636H4.44434C4.03524 12.3636 3.70377 12.0381 3.70377 11.6364C3.70377 11.2348 4.03524 10.9093 4.44434 10.9093H4.45339ZM4.45339 3.63644C4.86249 3.63644 5.19396 3.96188 5.19396 4.36356C5.19396 4.76523 4.86249 5.09067 4.45339 5.09067H4.44434C4.03524 5.09067 3.70377 4.76523 3.70377 4.36356C3.70377 3.96188 4.03524 3.63644 4.44434 3.63644H4.45339ZM18.5189 4.36356C18.5189 2.75687 17.1921 1.45422 15.5557 1.45422H4.44434C2.80792 1.45422 1.48115 2.75687 1.48115 4.36356C1.48115 5.97024 2.80792 7.27289 4.44434 7.27289H15.5557L15.7085 7.26934C17.2739 7.19126 18.5189 5.91992 18.5189 4.36356ZM20 4.36356C20 5.8819 19.2098 7.21833 18.0116 8C19.2098 8.78167 20 10.1181 20 11.6364C20 14.0465 18.0103 16 15.5557 16H4.44434C1.9897 16 0 14.0465 0 11.6364C0 10.1184 0.789618 8.78172 1.98752 8C0.789618 7.21828 0 5.88163 0 4.36356C0 1.95353 1.9897 0 4.44434 0H15.5557C18.0103 0 20 1.95353 20 4.36356Z" fill="#9AB9FF"/></svg> <span class="info-label">${__('Номер')}</span> <span class="info-value">${company || '—'}</span></div><div class="info-item"><svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.4493 8.94869C17.4493 8.33947 17.4421 8.18508 17.4058 8.05344C17.3677 7.91536 17.3052 7.78549 17.2212 7.67018C17.141 7.56025 17.0251 7.4594 16.5509 7.08519L9.97618 1.89718C9.79717 1.7559 9.69456 1.67573 9.61455 1.62149C9.5427 1.57279 9.53281 1.57516 9.55112 1.58019C9.51794 1.57107 9.48206 1.57107 9.44888 1.58019C9.46719 1.57516 9.4573 1.57279 9.38545 1.62149C9.30544 1.67573 9.20283 1.75591 9.02382 1.89718L2.44908 7.08519C1.97492 7.4594 1.85896 7.56025 1.77883 7.67018C1.69482 7.78549 1.63235 7.91536 1.59423 8.05344C1.55791 8.18508 1.55068 8.33947 1.55068 8.94869V16.0655C1.55068 16.6291 1.55114 17.0046 1.57435 17.2931C1.59684 17.5725 1.63686 17.7011 1.67753 17.7821C1.78907 18.004 1.9671 18.1848 2.1859 18.2979C2.26569 18.3391 2.39181 18.3788 2.66682 18.4016C2.95122 18.4252 3.32192 18.4266 3.87763 18.4266H15.1224C15.6781 18.4266 16.0488 18.4252 16.3332 18.4016C16.6082 18.3788 16.7343 18.3391 16.8141 18.2979C17.0329 18.1848 17.2109 18.004 17.3225 17.7821C17.3631 17.7011 17.4032 17.5725 17.4257 17.2931C17.4489 17.0046 17.4493 16.6291 17.4493 16.0655V8.94869ZM13.3776 14.4921C13.8059 14.4921 14.153 14.8442 14.153 15.2788C14.1528 15.7133 13.8059 16.0655 13.3776 16.0655H5.62237C5.19415 16.0655 4.84718 15.7133 4.84704 15.2788C4.84704 14.8442 5.19406 14.4921 5.62237 14.4921H13.3776ZM19 16.0655C19 16.6034 19.0012 17.0543 18.9716 17.4218C18.9413 17.7983 18.8751 18.1561 18.7046 18.4958C18.4445 19.0138 18.029 19.4353 17.5184 19.6993C17.1835 19.8725 16.8304 19.9394 16.4591 19.9702C16.0969 20.0002 15.6525 20 15.1224 20H3.87763C3.34751 20 2.90312 20.0002 2.54091 19.9702C2.16965 19.9394 1.81649 19.8725 1.48157 19.6993C0.971018 19.4353 0.555537 19.0138 0.295373 18.4958C0.124915 18.1561 0.0587343 17.7983 0.0284072 17.4218C-0.00118509 17.0543 6.58276e-06 16.6034 6.63039e-06 16.0655V8.57791C0.0031365 8.22484 0.0200519 7.92116 0.100355 7.62983C0.189351 7.30723 0.335714 7.00296 0.532044 6.73362C0.768523 6.40935 1.09203 6.16255 1.49672 5.84318L8.07145 0.654203C8.35532 0.430178 8.66867 0.164656 9.0437 0.0615343C9.34234 -0.0205114 9.65766 -0.0205114 9.9563 0.0615343C10.3313 0.164656 10.6447 0.430177 10.9285 0.654203L17.5033 5.84318C17.908 6.16255 18.2315 6.40935 18.468 6.73362C18.6643 7.00296 18.8107 7.30723 18.8996 7.62983C18.9799 7.92116 18.9969 8.22484 19 8.57791V16.0655Z" fill="#9AB9FF"/></svg> <span class="info-label">${__('Організація')}</span> <span class="info-value">${organization || '—'}</span></div></div></div>`;
};

// : api.contacts
//               .get(jid)
//               .then((contact) => !contact && not_me && can_see_real_jids)
//               .then((add) =>
//                   add
//                       ? html` <button
//                             class="btn btn-success w-100 mb-2"
//                             type="button"
//                             @click=${() => el.addToContacts()}
//                         >
//                             <converse-icon
//                                 class="fas fa-user-plus"
//                                 color="var(--background-color)"
//                                 size="1em"
//                             ></converse-icon>
//                             &nbsp;${__('Add as contact')}
//                         </button>`
//                       : '',
//               );
//    <!-- Секция кнопок действий -->
//         <!--<div class="mt-4">${chat_button} ${until(add_to_contacts, '')}</div>-->
